'use strict';

// This file intentionally bypasses Babel's Core-JS 3.0 entry rewrite.
require('core-js/modules/es.array.at');
